<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <el-card style="width: 100%">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Leltár eszközök</span>
          <el-button
            style="float: right; margin-top: -5px;"
            type="success"
            size="small"
            @click="$router.replace('/processes/stock-takings/stock-taking-tools/add')"
            icon="el-icon-plus"
            v-can="'stocktakingtool.create'"
          >
            Új leltár eszköz
          </el-button>
        </div>
        <div v-loading="loading" style="min-height: 81px;">
          <table-filter
            v-if="filterConfig"
            :config="filterConfig"
            action="stockTakingTool/fetchAll"
          />
        </div>
        <stock-taking-tool-list />
        <template v-if="$route.meta.showAddStockTakingToolDialog">
          <stock-taking-tool-dialog
            type="add"
          />
        </template>
        <template v-if="$route.meta.showUpdateStockTakingToolDialog">
          <stock-taking-tool-dialog
            :stock-taking-tool-id="$route.params.id"
            type="update"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>

<script>
  import StockTakingToolList from '../../../components/processes/stockTakings/stockTakingTools/List';
  import StockTakingToolDialog from '../../../components/processes/stockTakings/stockTakingTools/Dialog';
  import Sidebar from '../../../components/processes/stockTakings/Sidebar';
  import TableFilter from '../../../components/TableFilter';

  export default {
    components: {
      StockTakingToolDialog,
      StockTakingToolList,
      TableFilter,
      Sidebar,
    },
    data() {
      return {
        loading: false,
        filterConfig: null,
      };
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {

        this.filterConfig = [
          {
            type: 'text',
            name: 'name',
            label: 'Név',
            defaultSearch: true,
          },
        ];
      },
    },
  };
</script>
